// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3JtGM","header":"PatientQuestionnaire_header__qn6s_","info":"PatientQuestionnaire_info__PrfWm"};